import * as chatBubbles from '../../../Media/chat-bubbles.svg';
import * as accountCircle from '../../../Media/account_circle_white_24dp.svg';
import * as executed from '../../../Media/executed.png';
import * as inProgress from '../../../Media/in-progress.png';
import * as onHold from '../../../Media/on-hold.png';
import * as rejected from '../../../Media/rejected.png';
import * as house from '../../../Media/house.svg';
import * as chatSquareText from '../../../Media/chat-square-text.svg';
import * as boxArrowRight from '../../../Media/box-arrow-right.svg';
import * as plusCircle from '../../../Media/plus-circle.svg';
import * as geoAltFill from '../../../Media/geo-alt-fill.svg';
import * as sortDown from '../../../Media/sort-down-alt.svg';
import * as sortUp from '../../../Media/sort-up-alt.svg';
import * as search from '../../../Media/search.svg';
import * as threeDots from '../../../Media/three-dots.svg'

const imageUrl = {
    chatBubbles,
    accountCircle,
    executed,
    inProgress,
    onHold,
    rejected,
    house,
    chatSquareText,
    boxArrowRight,
    plusCircle,
    geoAltFill,
    sortDown,
    sortUp,
    search,
    threeDots
}
export default imageUrl